module.exports = __webpack_public_path__ + "img/img_level_17.7d433e5f.png";